import $ from "jquery";
import { areas } from "../framework/areas";
import { logger } from "../framework/logger";
import { regions } from "../framework/regions";
import { services } from "../services/notificationService";

function init() {
    populateRegions();
    populateAreas();
    $("#selectRegion").change(onRegionChanged);
}

function onRegionChanged() {
    regions.getRegions().done(function(lregions) {
        const selectedRegion = $("#selectRegion").val();
        if (!selectedRegion || selectedRegion === "")
            return;

        const selectedRegionObj = lregions.find(function(region) {
            return region.id === parseInt(selectedRegion);
        });

        if (selectedRegionObj && selectedRegionObj.areas && selectedRegionObj.areas.length) {
            const selectArea = $("#selectArea");
            selectArea.find("option").not(":first").remove().end();
            for (let selectAreaItem of selectedRegionObj.areas) {
                selectArea.append("<option value='" + selectAreaItem.id + "'>" + areas.getAreaName(selectAreaItem) + "</option>");
            }
        }
    });
}

function getFilters() {
    return {
        approvalTier: $("#selectApprovalTier").val(),
        areaId: toIntOrNull($("#selectArea").val()),
        hasApprover: $("#chkHasApprover").is(":checked"),
        programId: toIntOrNull($("#programId").val()),
        programName: $("#programName").val(),
        regionId: toIntOrNull($("#selectRegion").val())
    };
}
function getQueryStringFilters() {
    const filters = getFilters();
    for (const key in filters) {
        if (!filters[key]) {
            delete filters[key];
        }
    }
    return filters;
}
function toIntOrNull(val) {
    const parsed = parseInt(val);
    if (isNaN(parsed)) { return null; }
    return parsed;
}

function populateRegions() {
    return regions.getRegions().done(function (results) {
        const selectList = $("#selectRegion");
        selectList.find("option").not(":first").remove();
        for (let i = 0; i < results.length; i++) {
            $("#selectRegion")
                .append("<option value='" + results[i].id + "'>" + results[i].regionNumber + "</option>");
        }
    });
}

function populateAreas() {
    areas.getAreas().done(function (results) {
        const selectList = $("#selectArea");
        selectList.find("option").not(":first").remove();
        for (let i = 0; i < results.length; i++) {
            let name = results[i].name;
            name = name.replace("(assigned)", "");
            $("#selectArea").append("<option data-region='" + results[i].regionId + "' value='" + results[i].id + "'>" + name + "</option>");
        }
    });
}

export const courseApproverReportFilters = {
    init: init,
    getFilters: getFilters,
    getQueryStringFilters: getQueryStringFilters
};